import { Chip, Stack } from '@mui/material';
import type {
    SelectOption,
    SelectOptions,
} from './useSelectWithCheckboxesProps.ts';

export default function SelectedOptions({
    options,
    onDeleteOption,
}: {
    options: SelectOptions;
    onDeleteOption?: (option: SelectOption) => void;
    onClearOptions?: () => void;
}) {
    return (
        <Stack
            direction="row"
            display="inline-flex"
            justifyContent="end"
            flexWrap="wrap"
            gap={0.5}
        >
            {options.map((option) => (
                <Chip
                    color="primary"
                    key={option.value}
                    label={option.label}
                    onDelete={
                        onDeleteOption
                            ? () => {
                                  onDeleteOption(option);
                              }
                            : undefined
                    }
                    data-testid={option.value}
                />
            ))}
        </Stack>
    );
}
